import { isRefactorNinToViewSchemaEnabled } from '@atlassian/jira-issue-navigator-rollout/src/is-refactor-nin-to-view-schema-enabled.tsx';

export default {
	get(): boolean {
		return isRefactorNinToViewSchemaEnabled();
	},
};
